export default "__VITE_ASSET__Cnl76Bum__"